import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=3ac8c31d&scoped=true&lang=pug&"
import script from "./doctor.vue?vue&type=script&lang=ts&"
export * from "./doctor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac8c31d",
  null
  
)

export default component.exports